import type { V2ResourceToPermission } from "./types-v2";
import {
  type ResourcePermissionInput,
  useResourcePermission,
} from "./use-resource-permission";
import { resourcePermissionCopy } from "./with-permission";

export type UnauthorizedTooltip = {
  isDisabled: boolean;
  message: string | undefined;
  isLoading: boolean;
};

// Gating for controls that can't take a `Permissioned*` component (e.g. a
// generic `Select`, or a disabled element that swallows hover). Apply
// `isDisabled` to the control and `message` to its `Tooltip`.
export function useUnauthorizedTooltip<
  V2Resource extends V2ResourceToPermission,
>(
  permission: ResourcePermissionInput<V2Resource> | undefined,
): UnauthorizedTooltip {
  const { isPermitted, isLoading } = useResourcePermission(permission);
  const denied = !!permission && !isPermitted;
  return {
    isDisabled: denied,
    message:
      permission && denied && !isLoading
        ? resourcePermissionCopy(permission)
        : undefined,
    isLoading,
  };
}
